import { TTailwindString, tw } from "utils/tw";

interface Props {
  variant?: "left-aligned" | "stretched";
  className?: TTailwindString;
}

export default ({
  variant = "left-aligned",
  className,
  children,
}: React.PropsWithChildren<Props>): React.JSX.Element => {
  const cardBodyBase = tw("flex", "flex-col", "space-y-4");
  const leftAlignedStyles = tw("px-4", "items-start");
  const stretchedStyles = tw("px-4", "sm:px-10", "items-stretch");

  const cardBodyStyles = tw(cardBodyBase, className, {
    [leftAlignedStyles as string]: variant === "left-aligned",
    [stretchedStyles as string]: variant === "stretched",
  });

  return <div className={cardBodyStyles}>{children}</div>;
};
